import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "uploadDataBox comBox" }
const _hoisted_2 = { class: "sliderBox" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_4 = { style: {"font-size":"0.16rem","color":"#333333","font-weight":"bold"} }
const _hoisted_5 = { style: {"margin-top":"0.06rem"} }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { style: {"position":"absolute","bottom":"0","left":"0px","width":"300px","background-color":"rgba(51, 51,51 , .3)","height":"35px","z-index":"99","color":"#FFF","line-height":"35px"} }
const _hoisted_8 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_9 = { style: {"display":"flex","justify-content":"space-between","width":"100%"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  style: {"line-height":"104px"},
  class: "circle-span"
}
const _hoisted_13 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_14 = { style: {} }
const _hoisted_15 = { style: {"height":"329px","width":"100%"} }
const _hoisted_16 = ["src"]
const _hoisted_17 = { style: {"display":"grid","grid-template-columns":"repeat(5, minmax(0, 1fr))","column-gap":"12px","row-gap":"12px","margin-top":"20px"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  class: "",
  style: {"display":"flex","justify-content":"center","align-items":"center","column-gap":"20px","margin-top":"20px"}
}

import { UploadFilled, Search, Delete } from "@element-plus/icons-vue";
import { reactive, ref, watch } from "vue";
import { FormInstance, FormRules, ElMessage } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import { useRouter } from "vue-router";
import axios from "axios"
import uploadByPieces from "@/assets/js/uploadNew";
interface RuleForm {
  title: string;
  introduction: string;
  coverSheet: string;
  category1Id?: number;
  category2Id?: number;
  category1?: string;
  category2?: string;
  tags?: any;
  jobs?: string;
  video: string;
  authorizationMode: number;
  commentPermissions: number;
  publishMode: number;
  otherComposer: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'upload_data',
  props: {
  percentageValue: Number,
  filePath: String,
  fileName: String,
  jpimg: Array,
},
  setup(__props) {

const dialogVisible = ref(false);
const formSize = ref("default");
const props = __props;
const checkImg: any = ref("")
const coverClick = () => {
  checkImg.value = ruleForm.value.coverSheet ? ruleForm.value.coverSheet : props.jpimg[0];
  dialogVisible.value = true;
}
const base_file = (base64String: any, fileName: string) => {
  const byteCharacters = atob(base64String.split(',')[1]);
  const mimeString = base64String.split(',')[0].split(':')[1].split(';')[0];
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeString });
  return new File([blob], fileName, { type: mimeString });
}
const saveClick = async () => {
  if (checkImg.value.indexOf("base64") != -1) {
    let file = base_file(checkImg.value, String(new Date().getTime()));
    let p = new FormData();
    p.append("file", file);
    let res = await axios.post('https://api.biaoshisx.com/file/upload', p);
    if (res.data.code == 200) {
      let s: any = props.jpimg?.findIndex((item) => item === checkImg.value);
      props.jpimg?.splice(s, 1, res.data.data.url);
      ruleForm.value.coverSheet = res.data.data.url;
      dialogVisible.value = false;
    } else {
      ElMessage.error("操作失败");
    }
  } else {
    ruleForm.value.coverSheet = checkImg.value;
    dialogVisible.value = false;
  }
}

const openCreateUser = ref(false);
const upload_action = ref(serverBaseUrl + "/file/upload");
const nickName = ref("");
const other = ref<Array<any>>([]);
const tags = ref<Array<any>>([]);
const jobs = ref<Array<any>>([]);
const handleInput = (value) => {
  // console.log(value);
  // if (value) {
  //   return ElMessage.warning("最多输入10个标签");
  // }
  const selectId = document.querySelector("#selecttagsId");
  if (selectId) {
    selectId.setAttribute("maxLength", 10);
  }
  // if (value && value.target.value.length > 10) {
  //   let inputValue = value.target.value;
  //   const truncatedValue = inputValue.slice(0, 10);
  //   ruleForm.value.tags.pop();
  //   ruleForm.value.tags.push(truncatedValue);
  //   return ElMessage.warning("最多输入10个标签");
  // }
};
handleInput();
const AuthorizationModeList = ref([
  {
    value: 1,
    label: "不采用共享协议",
  },
  {
    value: 2,
    label: "署名-非商业性使用-禁止演绎",
    img: [
      "AuthorizationMode3.png",
      "AuthorizationMode4.png",
      "AuthorizationMode1.png",
    ],
  },
  {
    value: 3,
    label: "署名-非商业性使用-相同方式共享",
    img: [
      "AuthorizationMode3.png",
      "AuthorizationMode4.png",
      "AuthorizationMode2.png",
    ],
  },
  {
    value: 4,
    label: "署名-非商业性使用",
    img: ["AuthorizationMode3.png", "AuthorizationMode4.png"],
  },
  {
    value: 5,
    label: "署名-禁止演绎",
    img: ["AuthorizationMode3.png", "AuthorizationMode1.png"],
  },
  {
    value: 6,
    label: "署名-相同方式共享",
    img: ["AuthorizationMode3.png", "AuthorizationMode2.png"],
  },
  {
    value: 7,
    label: "署名",
    img: ["AuthorizationMode3.png"],
  },
]);
const router = useRouter();
const progressValue = (percentage: number) =>
  percentage === 100 ? "上传已完成" : `${percentage}%`;

// do not use same name with ref
const ruleForm = ref<RuleForm>({
  title: "",
  video: "",
  tags: [],
  introduction: "",
  coverSheet: "",
  commentPermissions: 1,
  publishMode: 0,
  authorizationMode: null,
  otherComposer: "",
});
let timer = <any>null; // 声明一个计时器变量
const handleEnter = (e: any) => { };
// console.log(val.trim());
// if (val.trim() !== "" && !tags1.value.includes(val.trim())) {
//   tags1.value.push(val.trim());
//   // Clear input value
//   e.target.value = "";
// }
// Update the v-model value
// ruleForm.value.tags = tags1.value;
// tags1.value = ruleForm.value.tags;
const handleRemove = (tag: any) => {
  tags1.value.at(-1) == tag ? tags1.value.pop() : "";
};
const tags1 = ref<Array<any>>([]);
const rules = reactive<FormRules<RuleForm>>({
  coverSheet: [{ required: true, message: "请上传封面", trigger: "change" }],
  title: [{ required: true, message: "请输入标题", trigger: "change" }],
  introduction: [{ required: true, message: "请输入简介", trigger: "change" }],
  category1Id: [{ required: true, message: "请选择分类", trigger: "change" }],
  tags: [{ required: true, message: "请输入标签", trigger: "change" }],
  authorizationMode: [
    { required: true, message: "请选择授权方式", trigger: "change" },
  ],
});
const ruleFormRef = ref<FormInstance>();
const OffFile = () => {
  ruleForm.value.coverSheet = "";
};
const loading = ref(false);
const beforeUpload = (file: any) => {
  const isJPGorPNG = file.type === "image/jpeg" || file.type === "image/png";
  const isLt6M = file.size / 1024 / 1024 < 6;

  if (!isJPGorPNG) {
    ElMessage.warning("只能上传JPG/PNG格式的文件!");
    return false;
  }
  if (!isLt6M) {
    ElMessage.warning("上传文件大小不能超过 6MB!");
    return false;
  }
  return isJPGorPNG && isLt6M;
};
const onSubmit = () => {
  ruleFormRef.value.validate(async (valid: boolean) => {
    if (valid) {
      let id = router.currentRoute.value.query.id;
      if (
        router.currentRoute.value.query.id
          ? ruleForm.value.percentageValue !== 100
          : props.percentageValue !== 100
      ) {
        return ElMessage.warning("请等待文件上传完成");
      }

      if (!props.filePath && !id) {
        return ElMessage.warning("请等待文件上传完成");
      }
      ruleForm.value.video = props.filePath;
      console.log(ruleForm.value.video);
      loading.value = true;
      let obj = { ...ruleForm.value };
      obj.tags = obj.tags.join(",");
      if (ruleForm.value.category1Id) {
        ruleForm.value.category1 = options.value.find(
          (x) => x.id == ruleForm.value.category1Id
        ).name;
      }
      if (ruleForm.value.category2Id) {
        ruleForm.value.category2 = options.value.find(
          (x) => x.id == ruleForm.value.category2Id
        ).name;
      }
      try {
        Axios("post", "/material/material/work/sou", obj, false, (res) => {
          if (res.data.code == 200) {
            loading.value = false;
            router.push({
              path: "ShadowUser",
            });
          } else {
            loading.value = false;
          }
        });
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
      }
    } else {
      return false;
    }
  });
};
const onSuccess = (res: any) => {
  ruleForm.value.coverSheet = res.data.url;
};
const options = ref([]);
const getTypes = () => {
  Axios(
    "post",
    "/material/material/workCategory/list",
    {
      pageIndex: 1,
      pageSize: 1000,
    },
    false,
    (res) => {
      options.value = res.data.data.records;
      options.value.shift();
    }
  );
};
const handelCreate = () => {
  openCreateUser.value = true;
};
const handleDelete = (index: number) => {
  other.value.splice(index, 1);
};
const handleQuery = () => {
  if (nickName.value) {
    Axios(
      "get",
      "/member/by",
      {
        nickName: nickName.value,
      },
      false,
      (res: any) => {
        if (!res.data.data) {
          ElMessage.warning("不存在此昵称的创作者");
          return;
        }
        if (other.value.findIndex((x) => x.id == res.data.memberId) > -1) {
          ElMessage.warning("已存在当前创作者");
          return;
        }
        let profess = "暂无职务";
        if (res.data.profess) {
          profess = res.data.profess;
        } else if (res.data.industry) {
          profess = res.data.industry;
        }
        other.value.push({
          id: res.data.data.memberId,
          name: res.data.data.nickName,
          avatar: res.data.data.avatar,
          profess: profess,
        });
        openCreateUser.value = false;
      }
    );
  }
};
const init = () => {
  let id = router.currentRoute.value.query.id;
  if (id) {
    Axios("get", `/material/material/work/${id}`, "", false, function (res) {
      if (res.data.code == 200) {
        // console.log(res);
        res.data.data.category3 = "";
        // tags1.value = res.data.data.tags.split(",");
        // res.data.data.tags = tags1.value;

        // console.log("tags1tags1tags1tags1tags1tags1tags1", tags1.value);

        ruleForm.value = res.data.data;
        // console.log(res.data.data.tags.split(","));

        ruleForm.value.tags = res.data.data.tags.split(",");
        // ruleForm.value.tags = res.data.data.tags.split(",");
        ruleForm.value.percentageValue = 100;
        // props.percentageValue = 100;
        // console.log(ruleForm.value);
      } else {
        ElMessage.error(res.data.message);
      }
      console.log("==========");
    });
  }
};
router.currentRoute.value.query ? init() : "";
// watch(
//   () => props.filePath,
//   (v: any) => {
//     ruleForm.value.video = v;
//   }
// );
watch(other.value, (v: any) => {
  ruleForm.value.otherComposer = v.map((x: any) => x.id).join(",");
});
// watch(
//   () => tags.value,
//   (v) => {
//     ruleForm.value.tags = v.join(",");
//   }
// );
watch(
  () => jobs.value,
  (v) => {
    ruleForm.value.jobs = v.join(",");
  }
);
getTypes();

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#333333","margin-bottom":"0.16rem"} }, " 发布视频 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.fileName
          ? __props.fileName
          : ruleForm.value.videoSource
            ? ruleForm.value.title +
            "." +
            ruleForm.value.videoSource.split(".").pop().split("?")[0]
            : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!ruleForm.value.percentageValue)
          ? (_openBlock(), _createBlock(_component_el_progress, {
              key: 0,
              percentage: __props.percentageValue,
              format: progressValue
            }, null, 8, ["percentage"]))
          : (_openBlock(), _createBlock(_component_el_progress, {
              key: 1,
              percentage: ruleForm.value.percentageValue,
              format: progressValue
            }, null, 8, ["percentage"]))
      ])
    ]),
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: ruleForm.value,
      "label-width": "100px",
      rules: rules,
      class: "demo-ruleForm",
      size: formSize.value,
      "status-icon": "",
      "label-position": "left"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "封面",
          prop: "coverSheet",
          style: {"position":"relative"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              class: "upload-demo",
              "show-file-list": false,
              drag: "",
              "before-upload": beforeUpload,
              action: upload_action.value,
              "on-success": onSuccess
            }, {
              default: _withCtx(() => [
                (ruleForm.value.coverSheet)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      src: ruleForm.value.coverSheet
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(UploadFilled))
                        ]),
                        _: 1
                      }),
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "el-upload__text" }, [
                        _createElementVNode("div", { style: {"font-size":"0.14rem","color":"#333333"} }, " 点击或拖拽文件到此处上传 "),
                        _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 图片尺寸至少302*180 "),
                        _createElementVNode("div", { style: {"font-size":"0.12rem","color":"#86909c"} }, " 支持JPG/PNG，不超过6MB ")
                      ], -1))
                    ])),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"flex":"1","text-align":"center","cursor":"pointer"} }, [
                      _createElementVNode("span", null, "本地上传")
                    ], -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("div", { style: {} }, [
                      _createElementVNode("span", null, "|")
                    ], -1)),
                    _createElementVNode("div", {
                      onClick: _withModifiers(coverClick, ["stop"]),
                      style: {"flex":"1","text-align":"center","cursor":"pointer"}
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("span", null, "推荐封面", -1)
                    ]))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["action"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "标题",
          prop: "title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: ruleForm.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.title) = $event)),
              "show-word-limit": "",
              maxlength: "40",
              placeholder: "请输入标题"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "视频简介",
          prop: "introduction"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              "show-word-limit": "",
              maxlength: "1000",
              modelValue: ruleForm.value.introduction,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.introduction) = $event)),
              placeholder: "请输入视频简介"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "分类",
          prop: "category1Id"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_select, {
                modelValue: ruleForm.value.category1Id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.value.category1Id) = $event)),
                placeholder: "请选择分类",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "标签",
          prop: "tags"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "tagType",
              style: {"width":"100%"},
              modelValue: ruleForm.value.tags,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.value.tags) = $event)),
              clearable: "",
              multiple: "",
              filterable: "",
              id: "selecttagsId",
              "reserve-keyword": false,
              "allow-create": "",
              "default-first-option": "",
              placeholder: "最多添加10个标签,每个标签最多20个字,按回车Enter创建标签",
              "multiple-limit": "10",
              s: '',
              onInput: handleInput
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags1.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "授权方式",
          prop: "authorizationMode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: ruleForm.value.authorizationMode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.value.authorizationMode) = $event)),
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(AuthorizationModeList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, {
                    default: _withCtx(() => [
                      (item.img)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.img, (img, imgIndex) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: imgIndex,
                                src: require(`@/assets/${img}`),
                                style: {"width":"20px","height":"20px","margin-right":"5px","border":"1px solid #fff","border-radius":"50%"}
                              }, null, 8, _hoisted_11))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12)),
                      _createTextVNode(" " + _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules", "size"]),
    _createVNode(_component_el_button, {
      type: "primary",
      loading: loading.value,
      class: "dataBtn",
      onClick: onSubmit
    }, {
      default: _withCtx(() => _cache[14] || (_cache[14] = [
        _createTextVNode("提交审核")
      ])),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_el_dialog, {
      title: "查找创作者",
      modelValue: openCreateUser.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((openCreateUser).value = $event)),
      "append-to-body": "",
      width: "350px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入成员昵称",
                  modelValue: nickName.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((nickName).value = $event)),
                  clearable: "",
                  onKeyup: _withKeys(handleQuery, ["enter"])
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (openCreateUser.value = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: handleQuery
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      style: {"border-radius":"12px"},
      top: "33px",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event)),
      "close-icon": "CircleCloseFilled",
      title: "选择推荐封面",
      width: "700"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              style: {"height":"329px","width":"100%","border-radius":"8px"},
              src: checkImg.value,
              alt: "",
              srcset: ""
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.jpimg, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (checkImg.value = item),
                key: item
              }, [
                _createElementVNode("img", {
                  style: {"height":"65px","border-radius":"8px","width":"100%","cursor":"pointer"},
                  src: item,
                  alt: "",
                  srcset: ""
                }, null, 8, _hoisted_19)
              ], 8, _hoisted_18))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (dialogVisible.value = false)),
              style: {"cursor":"pointer","border-radius":"8px","border":"1px solid #86909C","width":"88px","height":"37px","color":"#333333","font-size":"14px","text-align":"center","line-height":"37px"}
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("span", null, "取消", -1)
            ])),
            _createElementVNode("div", {
              onClick: saveClick,
              style: {"cursor":"pointer","border-radius":"8px","width":"88px","height":"37px","background":"#2978FF","color":"#ffffff","font-size":"14px","text-align":"center","line-height":"37px"}
            }, _cache[16] || (_cache[16] = [
              _createElementVNode("span", null, "保存", -1)
            ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})